import {NumberIDFolder, StringIDFolder} from 'constants/FolderConstants';
import ApolloHasTagSchemaFolderItemBase from 'folder-items/ApolloHasTagSchemaFolderItemBase';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {SchemaValidationState} from 'schemas/SchemaValidationConstants';
import {Optional} from 'util/Types';

import {BaseFolderItemFileGraphQL} from '../../graphql-fragments/nav/folder-items/__generated/BaseFolderItemFileGraphQL';

type BaseFolderItemFileGraphQL_BasicFolderItemNode = ExtractByTypename<
  BaseFolderItemFileGraphQL,
  'BasicFolderItemNode'
>;

export type AccessibleRegistryItemGraphQL = BaseFolderItemFileGraphQL_BasicFolderItemNode;

export default abstract class ApolloRegistryItemBase<
  TQuery,
  TFolderItemGraphQL extends AccessibleRegistryItemGraphQL,
> extends ApolloHasTagSchemaFolderItemBase<TQuery, TFolderItemGraphQL> {
  clearProjectFolder(): void {
    this.updateFolderItemAttributeInApolloCache('projectFolder', null);
  }

  setProjectFolder(folder: StringIDFolder | NumberIDFolder): void {
    this.updateFolderItemAttributeInApolloCache('projectFolder', {
      __typename: 'FolderNode',
      // Pull from api_identifier because the GraphQL folder shape requires string ID
      id: folder.api_identifier,
    });
  }

  setSchemaValidationState(schemaValidationState: Optional<SchemaValidationState>): void {
    this.updateFolderItemAttributeInApolloCache('schemaValidationStateJson', schemaValidationState || null);
  }

  setNameAndDisplayLabel(name: string, displayLabel: string): void {
    this.batchUpdateFolderItemAttributesInApolloCache({displayLabel, name});
  }
}
